export const hasAvailableAction = (props = {}, actions) => {
  if (!props || !props.available_actions || !Array.isArray(props.available_actions)) {
    return false
  }

  return (
    (Array.isArray(actions) ? actions : [actions]).filter(action =>
      props.available_actions.includes(action)
    ).length > 0
  )
}



// WEBPACK FOOTER //
// ./src/ui/gov-actions/helper.js